import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withXhr } from '@angular/common/http';
import { provideNativeDateAdapter } from '@angular/material/core';
import { provideCalAngular } from '@cvx/cal-angular';

import { routes } from './app.routes';
import { API_BASE_URL } from './core/services/api.base';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withXhr()),
    provideNativeDateAdapter(),
    provideCalAngular({
      autoSignIn: environment.autoSignIn,
      popupForLogin: environment.popupForLogin,
      cacheLocation: environment.cacheLocation,
      instance: environment.instance,
      tenantId: environment.tenantId,
      clientId: environment.clientId,
      redirectUri: environment.redirectUri,
      oidcScopes: environment.oidcScopes,
      graphScopes: environment.graphScopes,
    }),
    { provide: API_BASE_URL, useValue: environment.apiBaseUrl },
  ],
};
